import React, { useState } from 'react';

function SurveyStepNine({ formData, onNext }) {
    const [managerSupport, setManagerSupport] = useState(formData.managerSupport || '');
    const [managerComments, setManagerComments] = useState(formData.managerComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!managerSupport) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ managerSupport, managerComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 2: Career Development</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How supportive is your manager of your career goals and development? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`manager-support-${option}`}
                            name="managerSupport"
                            value={option}
                            checked={managerSupport === option}
                            onChange={() => setManagerSupport(option)}
                        />
                        <label htmlFor={`manager-support-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={managerComments}
                    onChange={(e) => setManagerComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!managerSupport}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepNine;
